// extracted by mini-css-extract-plugin
module.exports = {"varLinkOnLight":"var(--tkww-union-color-link-on-light, var(--tkww-union-color-additional-01extra-400, #0073E6))"};